import React from 'react';
import { useDispatch } from 'react-redux';
import { Grid, IconButton, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { ButtonLink, Icon, showDeleteDialog, Text } from 'app/main/components';
import { showFastAddDialog } from 'app/main/modules/components/FastAddDialog';

export default function SocialNetworksModuleListItem(props: ItemLayoutProps) {
	const dispatch = useDispatch();

	const editSocialNetwork = () => {
		dispatch(
			showFastAddDialog({
				module: 'socialnetworks',
				isUpdate: true,
				model: props.model,
				maxDialogWidth: 'sm',
				updateRefresh: props.buttonProps.updateRefresh
			})
		);
	};

	const deleteSocialNetwork = () =>
		dispatch(
			showDeleteDialog({
				module: 'socialnetworks',
				id: props.model.sone_uid,
				title: props.model.sone_title,
				updateRefresh: props.buttonProps.updateRefresh
			})
		);

	const secondaryAction = (
		<>
			<IconButton onClick={editSocialNetwork}>
				<Icon icon="pencil" />
			</IconButton>
			<IconButton onClick={deleteSocialNetwork} edge="end">
				<Icon icon="delete" />
			</IconButton>
		</>
	);

	return (
		<GridListItem secondaryAction={secondaryAction}>
			<Grid container justifyContent="space-between" alignItems="center" spacing={1}>
				<Grid size={{ sm: 6, xs: 12 }}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* WARNING */}
							{props.model.sone_warning_desc && (
								<Tooltip title={props.model.sone_warning_desc} arrow>
									<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
								</Tooltip>
							)}
							{/* BLOCKED */}
							{props.model.sone_blocked_desc && (
								<Tooltip title={props.model.sone_blocked_desc} arrow>
									<Icon className="mr-2" icon="block" color="error.main" />
								</Tooltip>
							)}
							{/* ICON */}
							<Icon className="mr-2" icon={props.model.soty_icon || 'web'} />
							{/* DESCRIPTION */}
							<Text className="font-600" variant="subtitle2">
								{props.model.sone_description || props.model.soty_title}
							</Text>
						</Grid>
						<Grid size={12}>
							{/* URL */}
							<ButtonLink href={props.model.sone_title}>{props.model.sone_title}</ButtonLink>
						</Grid>
					</Grid>
				</Grid>
				<Grid size={{ sm: 6, xs: 12 }}>
					<Grid container alignItems="center" spacing={1}>
						{/* LINKED PERSON */}
						{props.model.peop_uid && (
							<Grid>
								<ButtonLink
									href={`/people/details/${props.model.peop_uid}`}
									icon="card-account-details-outline"
								>
									{props.model.peop_title}
								</ButtonLink>
							</Grid>
						)}
						{/* LINKED COMPANY */}
						{props.model.comp_uid && (
							<Grid>
								<ButtonLink href={`/companies/details/${props.model.comp_uid}`} icon="domain">
									{props.model.comp_title}
								</ButtonLink>
							</Grid>
						)}
						{/* LINKED USER */}
						{props.model.user_uid && (
							<Grid>
								<ButtonLink href={`/users/details/${props.model.user_uid}`} icon="account-circle">
									{props.model.user_title}
								</ButtonLink>
							</Grid>
						)}
					</Grid>
				</Grid>
			</Grid>
		</GridListItem>
	);
}
